import React from 'react';

const BS_Forms = () => {
    return (
        <div>
            <h1>BS_Forms Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Forms;
